$(document).ready(function () {
  $("#shopify-section-template--16019878314028__17094615652657fc5c, #shopify-section-template--16016611868716__17094615652657fc5c").appendTo("#video-slides");

  //add to cart 
  $(".variant-radio").change(function() { 
    var container = $(this).closest(".item"); 
    var selectedVariant = container.find($(this)); 
       var priceDisplay = container.find($(".price"));
       var price = selectedVariant.data("per-pack-price") ;
       var variantImage = container.find($('.main-sticker'));
       var discountDisplay = container.find($(".discount-message "));
       var priceCompare = selectedVariant.data("compare-price");
      if (typeof price !== "undefined") {
        priceDisplay.text(price + ' each');
      } 
      var originalPrice = selectedVariant.data("percent-price");
      if (originalPrice) {
        var discountPercentage =  Math.round(((priceCompare - originalPrice) * 100) / priceCompare);
        discountDisplay.text(discountPercentage + "% OFF");  
      } else {
        discountDisplay.text("");
      }  

      var variantImageSrc = selectedVariant.data("variant-image");
      variantImage.attr('src', variantImageSrc);

    });


    $(".add-to-cart").click(function(event) {
    event.preventDefault();
    var container = $(this).closest(".item");
 
    var selectedVariant = container.find('input[type="radio"]:checked');
    var variantId = selectedVariant.val();
    var price = selectedVariant.data("price"); 
    if (!variantId) {
        console.error("No variant selected.");
        return;
    } 
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            quantity: 1,
            id: variantId
        },
        dataType: "json",
        success: function(response) {
            console.log("Variant added to cart successfully!");
            console.log(response);
            // have to timeout to outsmart iCart opening
            setTimeout(function () {
              window.location.href = "/checkout";
            }, 500);
            return false;
        },
        error: function(xhr, status, error) {
            console.error("Error adding variant to cart:");
            console.error(xhr.responseText);
        }
    });
});


  //end of add to cart

  // ========PURCHASE SLIDE==============
  for (let i = 1; i <= $("#purchaseSlide .item").length; i++) {
    $(".slider_dots-2").append(
      '<div class="slider_navigators"><div class="dot"></div></div>'
    );
  }

  $("#purchaseSlide").slick({
    slidesToShow: 3,
    dots: false,
    arrows: true,
    asNavFor: ".slider_dots-2",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 340,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "20px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".slider_dots-2").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: "#purchaseSlide",
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: "60px",
  });

//   const showImage = () => {
//   if (window.innerWidth > 768) {
//     setTimeout(() => {
//       $('.hero-side-img').show();
//     }, 2000);
//   }else {
//     $('.hero-side-img').hide();
//   }
// };
// showImage()
// window.addEventListener('resize', showImage);

$('div[data-widget-host="habitat-static-feed"]').appendTo('.instagram-video-slides');

  // Homepage Carousel Slide 
  for (let i = 1; i <= $(".hero-carousel li").length; i++) {
    $(".home-carousel-dots").append(
      '<div class="slider_navigators"><div class="dot"></div></div>'
    );
  }
  $('.hero-carousel').on('init', function() {
  $('.hero-carousel').css('visibility', 'visible');
  }).slick({
    slidesToShow: 1,
    centerPadding: "25%",
    variableWidth: false,
    autoplay: true,
    dots: false,
    arrows: false,
    centerMode: true,
    asNavFor: ".home-carousel-dots",
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0",
          slidesToShow: 1,
        },
      },
    ],
  })

  $('.home-carousel-dots').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".hero-carousel",
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: "60px",
  });

  // ==========VIDEO SLIDES=========

  // $("#video-slides").slick({
  //   arrows: false,
  //   centerPadding: "20px",
  //   slidesToShow: 5,
  //   responsive: [
  //     {
  //       breakpoint: 769,
  //       settings: {
  //         arrows: false,
  //         centerMode: true,
  //         centerPadding: "40px",
  //         slidesToShow: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 340,
  //       settings: {
  //         arrows: false,
  //         centerMode: true,
  //         centerPadding: "80px",
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // });

  // ========REVIEW SLIDES=========
  for (let i = 1; i <= $("#review-slides .item").length; i++) {
    $(".slider_dots-1").append(
      '<div class="slider_navigators"><div class="dot"></div></div>'
    );
  }

  $("#review-slides").slick({
    infinite: true,
    arrows: false,
    centerMode: true,
    centerPadding: "50px",
    slidesToShow: 1,
    asNavFor: ".slider_dots-1",
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
        },
      },
    ]
  });

  $(".slider_dots-1").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: "#review-slides",
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: "60px",
  });

  // =========REVIEW SLIDES 2=========== //

  for (let i = 1; i <= $("#review-slides-2 .item").length; i++) {
    $(".slider_dots-3").append(
      '<div class="slider_navigators"><div class="dot"></div></div>'
    );
  }

  $("#review-slides-2").slick({
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "10%",
    dots: false,
    asNavFor: ".slider_dots-3",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: false,
          slidesToShow: 2,
          dots: false,
          asNavFor: ".slider_dots-3",
        },
      },
      {
        breakpoint: 769,
        settings: {
          centerPadding: "60px",
          arrows: false,
          slidesToShow: 1,
          dots: false,
          asNavFor: ".slider_dots-3",
        },
      },
      {
        breakpoint: 431,
        settings: {
          centerPadding: "30px",
          arrows: false,
          slidesToShow: 1,
          dots: false,
          asNavFor: ".slider_dots-3",
        },
      },
      {
        breakpoint: 376,
        settings: {
          centerPadding: "15px",
          arrows: false,
          slidesToShow: 1,
          dots: false,
        },
      },
      {
        breakpoint: 340,
        settings: {
          centerPadding: "5px",
          arrows: false,
          slidesToShow: 1,
          dots: false,
          asNavFor: ".slider_dots-3",
        },
      },
    ],
  });

  $(".slider_dots-3").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: "#review-slides-2",
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: "60px",
  });

  // ===========VERIFIED BUYER SLIDES============
  for (let i = 1; i <= $("#verified-buyer-slide .item").length; i++) {
    $(".slider_dots-4").append(
      '<div class="slider_navigators"><div class="dot"></div></div>'
    );
  }
  $("#verified-buyer-slide").slick({
    arrows: false,
    slidesToShow: 3,
    asNavFor: ".slider_dots-4",
    autoplay: true, 
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 2,
          asNavFor: ".slider_dots-4",
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
          asNavFor: ".slider_dots-4",
        },
      },
    ],
  });

  $(".slider_dots-4").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: "#verified-buyer-slide",
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: "60px",
  });

  // ===========PRODUCTS USE SLIDE=============

  $("#products-use-slide").slick({
    arrows: false,
    centerMode: true,
    centerPadding: "0px",
    slidesToScroll: 3,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "80px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 340,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "50px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $("#products-use-slide-2").slick({
    arrows: true,
    centerPadding: "80px",
    slidesToShow: 1,
    vertical: true,
    verticalSwiping: true,
    useTransform: false,
  });

  // ===========REVIEW DESKTOP=========

  $("#review-slides-ds").slick({
    arrows: true,
    slidesToShow: 1,
    dots: true,
    cssEase: "linear",
    speed: 500,
    fade: true,
  });

  // =======HIDE SHOW TEXT==========
  const readmore = $(".readmore");

  readmore.each(function () {
    let el = $(this);
    const fullText = el.prev().text();
    const sliceText = el.prev().text().slice(0, 200);
    el.prev().text(sliceText + "...");

    el.click(function () {
      const target = $(this);

      if (el.text() === "Show less") {
        target.prev().text(sliceText + "...");
        target.text("Read more");
      } else {
        target.text("Show less");
        target.prev().text(fullText);
      }
    });
  });

  //

  let isScrolled = false
  // $(window).scroll(function () {
  //   isScrolled = true
  //   console.log(isScrolled)
  //   // $(".nav-up").fadeIn();
  // });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
      $(".nav-up").fadeIn();
    } else {
      $(".nav-up").fadeOut();
    }
    });
  });

  function onScroll() {
    isScrolled = true;
    if (isScrolled) {
      observer.observe(document.querySelector("#hero__sec"));
      $(window).off("scroll", onScroll);
    }
  }
  $(window).on("scroll", onScroll);

  // Add Fixed Button
  const categorySection = document.querySelector('#trust-pilot');
  const heroBtn = document.querySelector('.hero-btn-container');
  const handleIntersection = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
          heroBtn.classList.add('active');
        } 
      });
  };

  const options = {
    root: null,
    threshold: 0.1 
  };

    const observer2 = new IntersectionObserver(handleIntersection, options);
    observer2.observe(categorySection);

    // Remove Fixed Button
    const removeFixedClass = (element, options) => {
      const handleIntersection2 = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
          heroBtn.classList.remove('active');
        } else {
          heroBtn.classList.add('active');
        }
      });
    };

    const observer3 = new IntersectionObserver(handleIntersection2, options);
    observer3.observe(element);
    }
  const heroSection = document.querySelector('.hero-carousel-container');
  const footerSection = document.querySelector('footer.footer');
  removeFixedClass(heroSection, options)
  removeFixedClass(footerSection, options)
 
});

